import React, { useContext, useState } from 'react'
import { Button, Input, Notification, toast } from 'components/ui'
import { CompanyContext } from 'contexts/CompanyContext'
import { PriorityModalContext } from 'contexts/PriorityModalContext';
import { api as Api } from 'api/http';
import { SessionContext } from 'contexts/SessionContext';
import { Trans } from 'react-i18next';

const BlueskyIntegrationModal = () => {

    const { updateUserData } = useContext(SessionContext);
    const { company, updateSocials } = useContext(CompanyContext);
    const [handle, setHandle] = useState("");
    const [appPassword, setAppPassword] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const { closeModalPriority } = useContext(PriorityModalContext);

    const handleSubmit = () => {
        setIsLoading(true);
        Api.post(`/companies/${company?.id}/socialNetworks`, {}, { type: "bluesky", social_token: appPassword, handle: handle }).then((response) => {
            updateUserData();
            updateSocials();
            closeModalPriority();
        }).catch((err) => {
            toast.push(<Notification title={err.message || "Invalid Bluesky handle or app password"} type="danger" />);
        }).finally(() => {
            setIsLoading(false);
        });
    }

    return (
        <>
            <div className='flex flex-col gap-8'>
                <img src="/img/socials/bluesky.svg" className='w-20 h-20 mx-auto drop-shadow' alt="Bluesky" />
                <div className='flex flex-col gap-3'>
                    <h3 className='text-tertiary-900 mega-title text-center'>
                        <Trans i18nKey="blueskyIntegration.title">Bluesky Integration</Trans>
                    </h3>
                    <p className='text-center'>
                        <Trans i18nKey="blueskyIntegration.subtitle">
                            To publish on behalf of your Bluesky account, you'll need to create an App Password. This grants limited access without exposing your main password.
                        </Trans>
                    </p>
                </div>

                <div className="overflow-y-auto flex flex-col gap-2.5">
                    <div className={`flex justify-between items-center gap-4 rounded-2xl py-1.5 px-4 transition-all`}>
                        <div className='flex items-center gap-4'>
                            <div className='w-10 h-10 bg-primary-600/30 border-4 border-primary-600/10 flex items-center justify-center rounded-full overflow-hidden'>
                                <h4 className='mega-title p-0 -mt-1'>1</h4>
                            </div>
                            <div className='w-full flex-1 text-tertiary-800 dark:text-gray-100'>
                                <Trans i18nKey="blueskyIntegration.step1">Log into your Bluesky account</Trans>: <a href='https://bsky.app' target="_blank" rel="noreferrer" className="!text-primary-600">bsky.app</a>
                            </div>
                        </div>
                    </div>
                    <div className={`flex justify-between items-center gap-4 rounded-2xl py-1.5 px-4 transition-all`}>
                        <div className='flex items-center gap-4'>
                            <div className='w-10 h-10 bg-primary-600/30 border-4 border-primary-600/10 flex items-center justify-center rounded-full overflow-hidden'>
                                <h4 className='mega-title p-0 -mt-1'>2</h4>
                            </div>
                            <div className='w-full flex-1 text-tertiary-800 dark:text-gray-100'>
                                <Trans i18nKey="blueskyIntegration.step2">Go to Settings &gt; App Passwords and create a new app password</Trans>: <a href='https://bsky.app/settings/app-passwords' target="_blank" rel="noreferrer" className="!text-primary-600">bsky.app/settings/app-passwords</a>
                            </div>
                        </div>
                    </div>
                    <div className={`flex justify-between items-center gap-4 rounded-2xl py-1.5 px-4 transition-all`}>
                        <div className='flex items-center gap-4 w-full'>
                            <div className='w-10 h-10 bg-primary-600/30 border-4 border-primary-600/10 flex items-center justify-center rounded-full overflow-hidden'>
                                <h4 className='mega-title p-0 -mt-1'>3</h4>
                            </div>
                            <div className='w-full flex-1 text-tertiary-800 dark:text-gray-100'>
                                <Input
                                    className="!w-full bg-tertiary-100 dark:bg-gray-900 !border-0 !rounded-2xl"
                                    value={handle}
                                    onChange={(e) => setHandle(e.target.value)}
                                    placeholder="Your Bluesky handle (e.g. user.bsky.social)"
                                />
                            </div>
                        </div>
                    </div>
                    <div className={`flex justify-between items-center gap-4 rounded-2xl py-1.5 px-4 transition-all`}>
                        <div className='flex items-center gap-4 w-full'>
                            <div className='w-10 h-10 bg-primary-600/30 border-4 border-primary-600/10 flex items-center justify-center rounded-full overflow-hidden'>
                                <h4 className='mega-title p-0 -mt-1'>4</h4>
                            </div>
                            <div className='w-full flex-1 text-tertiary-800 dark:text-gray-100'>
                                <Input
                                    className="!w-full bg-tertiary-100 dark:bg-gray-900 !border-0 !rounded-2xl"
                                    type="password"
                                    value={appPassword}
                                    onChange={(e) => setAppPassword(e.target.value)}
                                    placeholder="Paste your app password here"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className='flex justify-end gap-2 p-4 -m-6 w-auto mt-10 border-t border-gray-200 dark:border-gray-700'>
                <Button onClick={closeModalPriority}>
                    <Trans i18nKey="blueskyIntegration.cancel">Cancel</Trans>
                </Button>
                <Button 
                    loading={isLoading} 
                    disabled={!handle || !appPassword} 
                    variant="solid" 
                    onClick={handleSubmit} 
                    icon={<img src="/img/socials/bluesky.svg" className="!h-4 !w-4 shrink-0" alt="" />}
                >
                    &nbsp; <Trans i18nKey="blueskyIntegration.connectBluesky">Connect Bluesky</Trans>
                </Button>
            </div>
        </>
    )
}

export default BlueskyIntegrationModal
